const PastPickupIcon = ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M2.66669 1.16669H13.3334C14.438 1.16669 15.3334 2.06211 15.3334 3.16669V9.51855C14.9486 9.17422 14.4968 8.90322 14 8.72762V3.16669C14 2.7985 13.7016 2.50002 13.3334 2.50002H2.66669C2.2985 2.50002 2.00002 2.7985 2.00002 3.16669V13.8334C2.00002 14.2016 2.2985 14.5 2.66669 14.5H9.20182C9.51142 15.0352 9.94142 15.492 10.4548 15.8334H2.66669C1.56212 15.8334 0.666687 14.938 0.666687 13.8334V3.16669C0.666687 2.06212 1.56211 1.16669 2.66669 1.16669Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33331 12.5C9.33331 10.66 10.8266 9.16669 12.6666 9.16669C14.5066 9.16669 16 10.66 16 12.5C16 14.34 14.5066 15.8334 12.6666 15.8334C10.8266 15.8334 9.33331 14.34 9.33331 12.5ZM12.3333 12.6334L13.7666 14.0667L14.2333 13.5934L13 12.36V10.5H12.3333V12.6334Z"
        fill={color}
      />
    </svg>
  );
};

export default PastPickupIcon;
